import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import VModal from 'vue-js-modal'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import store from '@/store'
import VueSessionStorage from 'vue-sessionstorage'
import { DatePicker } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import eLocale from "element-ui/lib/locale";
import elementLocale from 'element-ui/lib/locale/lang/hu';
eLocale.use(elementLocale)

Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VModal, {dialog : true})
Vue.use(VueSessionStorage)
Vue.use(DatePicker)


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
